module.exports = __webpack_public_path__ + "static/img/43.f0067f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/43.png
// module id = GTza
// module chunks = 0